import React from "react";
import { useNavigate } from "react-router-dom";

import aaImage from "../../assets/Images/anubavam.jpeg";
import aaImage1 from "../../assets/Images/santhipu.jpeg";
import aaImage2 from "../../assets/Images/ilakiyam.jpeg";
import aaImage3 from "../../assets/Images/varalaru.jpeg";
import aaImage4 from "../../assets/Images/works.jpeg";
import aaImage5 from "../../assets/Images/msd.jpeg";
import aaImage6 from "../../assets/Images/slogan.jpg";
import aaImage7 from "../../assets/Images/audiofile.jpg"; // new image

const cards = [
  { id: 1, title: "AAவில் உள்ளவர்களின் அனுபவம், தெம்பு, மற்றும் நம்பிக்கை", image: aaImage },
  { id: 2, title: "Online AA meeting list", image: aaImage1 },
  { id: 3, title: "Slogans are wisdom written in shorthand", image: aaImage6 },
  { id: 4, title: "Literature", image: aaImage2 },
  { id: 5, title: "AAவின் வரலாற்று சுருக்கம்", image: aaImage3 },
  { id: 6, title: "ஏ.ஏ. எப்படி செயல்படுகிறது", image: aaImage4 },
  { id: 7, title: "Big Book Tamil Audio file", image: aaImage7 }, // NEW CARD
  { id: 8, title: "கோட்பாடுகளின் சிறு தொகுப்பு", image: aaImage5 },
];

export default function AACardGrid() {

  const navigate = useNavigate();

  const handleCardClick = (title) => {

    if (title === "Slogans are wisdom written in shorthand")
      navigate("/slogans");

    else if (title === "Online AA meeting list")
      navigate("/aa-meetings");

    else if (title === "AAவில் உள்ளவர்களின் அனுபவம், தெம்பு, மற்றும் நம்பிக்கை")
      navigate("/aa-experience");

    else if (title === "Literature")
      navigate("/literature");

    else if (title === "AAவின் வரலாற்று சுருக்கம்")
      navigate("/aa-history");

    else if (title === "கோட்பாடுகளின் சிறு தொகுப்பு")
      navigate("/twelve-principles");

    else if (title === "ஏ.ஏ. எப்படி செயல்படுகிறது")
      navigate("/how-aa-works");

    else if (title === "Big Book Tamil Audio file")
      navigate("/bigbook-audio");   // NEW PAGE

    else
      alert(`${title} page coming soon`);
  };

  return (

    <section className="py-8 px-4 lg:px-8 bg-gray-50">

      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-6px); }
            100% { transform: translateY(0px); }
          }

          .fade-animate {
            animation: fadeUp 0.8s ease forwards;
          }

          .float-card {
            animation: float 3s ease-in-out infinite;
          }

          .card-animated:hover {
            transform: scale(1.07) translateY(-8px) rotateX(6deg) rotateY(6deg);
            box-shadow: 0 12px 30px rgba(0,0,0,0.22);
            border: 2px solid rgba(0,95,255,0.5);
          }

          .icon-box:hover .icon-inner {
            transform: scale(1.2) rotate(6deg);
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

          {cards.map((c, index) => (

            <article
              key={c.id}
              onClick={() => handleCardClick(c.title)}
              style={{ animationDelay: `${index * 0.15}s` }}

              className="
              fade-animate float-card card-animated
              relative overflow-hidden rounded-2xl p-6
              shadow-md bg-gradient-to-br 
              from-blue-100 to-blue-300 cursor-pointer
              transition-all duration-300 ease-out
              "
            >

              <div className="flex flex-col items-center justify-center gap-4">

                <div className="icon-box flex-shrink-0 w-20 h-20 rounded-full 
                bg-white/80 backdrop-blur flex items-center justify-center shadow">

                  <img
                    src={c.image}
                    alt="AA Icon"
                    className="icon-inner w-14 h-14 object-contain transition-all duration-300"
                  />

                </div>

                <h3 className="text-lg font-semibold text-gray-900 leading-snug text-center">
                  {c.title}
                </h3>

              </div>

            </article>

          ))}

        </div>

      </div>

    </section>

  );
}